export const TEN_MEGABYTES = 10 * 1024 * 1024;
export const FIFTY_MEGABYTES = 5 * TEN_MEGABYTES;
